import React from "react"

export const columnConfig = () => [
  {
    accessor: "id",
    title: "Id",
    sortable: true,
  },
  {
    accessor: "user.full_name",
    title: "IG Tam İsim",
    sortable: true,
  },
  {
    accessor: "user.is_private",
    title: "Kullanıcı Hesap Gizliliği",
    sortable: true,
    render: (value: any) => {
      const isPrivate = value === "true" ? true : false
      return isPrivate ? "True" : "False"
    },
  },
  {
    accessor: "user.username",
    title: "IG Kullanıcı Adı",
    sortable: true,
    render: (rowData) => {
      const username = rowData.user.username
      return (
        <a href={`https://www.instagram.com/${username}`} target="_blank" rel="noopener noreferrer">
          {username}
        </a>
      )
    },
  },
  {
    accessor: "s3_url",
    title: "S3 URL",
    sortable: true,
    render: (rowData) => {
      const s3_url: string = rowData.s3_url as string
      return (
        <a href={s3_url} target="_blank" rel="noopener noreferrer">
          {s3_url}
        </a>
      )
    },
  },

  {
    accessor: "owner.full_name",
    title: "Gönderi Sahibi Tam İsmi",
    sortable: true,
  },
  {
    accessor: "owner.is_private",
    title: "Gönderi Sahibi Hesap Gizliliği",
    sortable: true,
    render: (value: any) => {
      const isPrivate = value === "true" ? true : false
      return isPrivate ? "True" : "False"
    },
  },
  {
    accessor: "media_id",
    title: "Medya ID",
    sortable: true,
  },
  {
    accessor: "like_and_view_counts_disabled",
    title: "Beğeni ve Görüntüleme Sayısı Gizliliği",
    sortable: true,
    render: (value: any) => {
      const isDisabled = value === "true" ? true : false
      return isDisabled ? "True" : "False"
    },
  },
  {
    accessor: "commerciality_status",
    title: "Ticarilik Durumu",
    sortable: true,
    render: (value: any) => {
      const isStatus = value === "true" ? true : false
      return isStatus ? "True" : "False"
    },
  },
  {
    accessor: "like_count",
    title: "Beğeni Sayısı",
    sortable: true,
  },
  {
    accessor: "media_type",
    title: "Medya Türü",
    sortable: true,
  },

  {
    accessor: "is_paid_partnership",
    title: "Sponsorlu İçerik",
    sortable: true,
    render: (value: any) => {
      const isPaid = value === "true" ? true : false
      return isPaid ? "True" : "False"
    },
  },
  {
    accessor: "comment_count",
    title: "Yorum Sayısı",
    sortable: true,
  },
  {
    accessor: "caption_created_at",
    title: "Açıklama Oluşturulma Tarihi",
    sortable: true,
  },
  {
    accessor: "description",
    title: "Açıklama",
    sortable: true,
  },
]
